<template>
    <div class="padding-content white-content mb-4">    
        <div class="h2 mb-1"> <span>{{ $t('general.abono', {abono: teatro.texto_abono}) }} {{ index }}</span></div>
        <div class="h5 mb-4 regular" v-if="abono.asiento && abono.asiento.zona_nombre">{{ abono.asiento.zona_nombre }} /
            {{ $t('general.fila') }}: {{ abono.asiento.fila }} / {{ $t('general.butaca') }} {{ abono.asiento.asiento }}
        </div>
        <div class="h5 mb-4 regular" v-if="abono.plaza">
            <template v-if="abono.plaza.sector_name">
                {{ abono.plaza.sector_name }} /
            </template>
            <template v-if="abono.plaza.fila && abono.plaza.butaca">
                {{ $t('general.fila') }}: {{ abono.plaza.fila }} / {{ $t('general.butaca') }} {{ abono.plaza.butaca }}
            </template>
            <template v-else>
                {{ $t('general.plaza') }} {{ abono.plaza.numero }}
            </template>
            <span v-if="abono.plaza.visibilidad_reducida || abono.plaza.porcentaje_visibilidad">
                &nbsp;-&nbsp;
            </span>
            <span v-if="abono.plaza.visibilidad_reducida" class="text-danger">
                {{ $t('visibilidad_reducida.nombre') }}
            </span>
            <span v-if="abono.plaza.porcentaje_visibilidad" class="text-danger">
                : {{ abono.plaza.porcentaje_visibilidad }}%
            </span>
        </div>
        <div class="h5 mb-4 regular" v-if="abono.tipo_abono">{{ abono.tipo_abono.descripcion}}</div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :label="$t('formularios.nombre')" 
                    :name="'nombre' + index" 
                    rules="required"
                    v-model="localAbono.nombre"
                    @input="updateParent" 
                    :disabled="bloquear_nombre_y_apellidos_en_renovacion || desactivar"
                    :style="bloquear_nombre_y_apellidos_en_renovacion ? 'text-decoration: line-through; color: grey;' : ''" 
                />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :label="$t('formularios.apellidos')" 
                    :name="'apellidos' + index" 
                    rules="required"
                    v-model="localAbono.apellidos"
                    @input="updateParent"
                    :disabled="bloquear_nombre_y_apellidos_en_renovacion || desactivar"
                    :style="bloquear_nombre_y_apellidos_en_renovacion ? 'text-decoration: line-through; color: grey;' : ''" 
                />
            </div>

            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <label>{{ $t('formularios.genero') }}</label>
                    <ValidationProvider :name="'genero' + index" rules="required" v-slot="{ errors }">
                        <multiselect 
                            :id="'genero' + index" 
                            :disabled="desactivar" 
                            v-model="localAbono.genero"
                            @input="updateParent"
                            :placeholder="$t('formularios.genero')" 
                            label="name" track-by="id" :options="generos"
                            class="custom-multiselect" @select="(option, id) => localAbono.genero_id = option.id"
                        />
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs error-message">
                            <b>{{ errors[0]}}</b>
                        </span>
                    </ValidationProvider>
                </div>
            </div>
            <b-col cols="12" md="6" lg="4">
                <ValidationProvider name="tipo de documento" rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>{{ $t('formularios.tipo_identificacion') }}</label>
                        <multiselect
                            v-model="localAbono.tipoDocumentoSeleccionado"
                            label="type"
                            track-by="type"
                            class="custom-multiselect"
                            :class="(errors[0] ? 'is-invalid' : '')"
                            :id="'tipo-documento-' + index"
                            :placeholder="$t('formularios.tipo_identificacion')"
                            :options="tiposDocumento"
                            @input="onSeleccionTipoDocumento"
                            data-cy="multiselect-documento"
                        />
                        <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" >
                            {{ errors[0] }}
                        </span>
                    </div>
                </ValidationProvider>
            </b-col>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <div v-if="info_text" class="d-flex align-items-center">
                        <label class="mr-1">{{ texto_documentacion }}</label>
                        <InfoToolTip :info="info_text" class="pb-1" />
                    </div>
                    <label v-else>{{ texto_documentacion }}</label>
                    <ValidationProvider 
                        :name="texto_documentacion"
                        :rules="{ required: true, identificacion: { tipo: localAbono.tipoDocumentoSeleccionado?.type } }"
                        v-slot="{ errors }"
                    >
                        <input 
                            v-model="localAbono.dni"
                            @input="updateParent" 
                            id="dni"
                            type="text" 
                            :disabled="desactivar || !localAbono.tipoDocumentoSeleccionado"
                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            :placeholder="texto_documentacion"
                        />
                        <span 
                            v-if="errors[0]" 
                            class="invalid-feedback text-xs"
                            style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                        >
                            <b>{{errors[0] }}</b>
                        </span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <label for="fecha_nacimiento">{{ $t('formularios.nacimiento') }}</label>
                    <ValidationProvider :name="'fecha_nacimiento' + index" rules="required" v-slot="{ errors }">
                        <input 
                            type="date" 
                            v-model="localAbono.fecha_nacimiento"
                            id="fecha_nacimiento"
                            name="fecha_nacimiento" 
                            min="1900-01-01" 
                            max="2999-12-31"
                            @input="() => { updateParent();if (!manager.lfp) debouncedGetPrecio() }"
                            :disabled="desactivar"
                        />
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs error-message">
                            <b>{{ errors[0]}}</b>
                        </span>
                    </ValidationProvider> 
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :disabled="desactivar" 
                    :label="$t('formularios.email')" 
                    :name="'email' + index"
                    rules="required|email" 
                    v-model="localAbono.email"
                    @input="updateParent" 
                />
            </div>
            <div class="col-12 col-md-6 col-lg-4 mb-2">
                <div class="form-group">
                    <label>{{ $t('formularios.telefono') }}</label>
                    <PhoneInput 
                        :key="error_telefono" 
                        :name="'telefono' + index" 
                        :phone="localAbono.telefono ?? null"
                        :desactivar="desactivar" 
                        :forceValidate="true" 
                        :error_telefono="error_telefono"
                        @setNumber="(number) => { localAbono.telefono = number; updateParent(); }"
                        @validNumber="(valid) => { localAbono.telefono_valido = valid; updateParent(); }"
                        @input="updateParent"
                    />
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Paises 
                        :desactivar="desactivar" 
                        :errors="errors" 
                        @rellenarPais="rellenarPais"
                        v-on:selected="opt => { pais = opt; localAbono.pais = opt.nombre; updateParent(); }"
                    />
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Provincias 
                        :desactivar="desactivar" 
                        :errors="errors" :pais="pais.id" 
                        :provincia="provincia"
                        v-on:selected="opt => { provincia = opt; localAbono.provincia = opt.nombre; updateParent(); }"
                    />
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Locations 
                        :desactivar="desactivar" 
                        :provincia="provincia"
                        :localidad="localAbono.localidad"
                        :errors="errors"
                        v-on:selected="opt => { localAbono.localidad = opt.nombre; updateParent(); }" 
                    />
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :disabled="desactivar" 
                    :label="$t('formularios.domicilio')" 
                    :name="'domicilio' + index"
                    rules="required" 
                    v-model="localAbono.domicilio"
                    @input="updateParent" 
                />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :disabled="desactivar" 
                    :label="$t('formularios.cp')" 
                    :name="'cp' + index" 
                    rules="required"
                    v-model="localAbono.cp"
                    @input="updateParent" 
                />
            </div>
            <div v-if="mostrar_iban == true" class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :disabled="desactivar" 
                    :label="$t('formularios.iban')" 
                    :name="'iban' + index"
                    rules="required" 
                    v-model="localAbono.iban"
                    @input="updateParent" 
                />
            </div>
            <div v-if="mostrar_titular_cuenta == true" class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :disabled="desactivar" 
                    :label="$t('formularios.titular_cuenta')"
                    :name="'titular_cuenta' + index" 
                    rules="required" 
                    v-model="localAbono.titular_cuenta"
                    @input="updateParent" 
                />
            </div>
            <template v-if="fields && fields.length > 0">
                <div 
                    v-for="(field, i) in fields" 
                    :key="i"
                    :class="'col-12' + (field.type !== 'textarea' ? ' col-lg-4' : '')"
                >
                    <FieldComponent 
                        :field="field" 
                        :desactivar="desactivar"
                        :fieldIndex="index" 
                        v-model="localAbono.properties[field.name]" 
                        @input="updateParent"
                    />
                </div>
            </template>
            <b-col cols="12" class="mb-3" v-if="false" style="display:none">
                <hr />
                <h4>¡Murcianista!</h4>
                <p>Esta temporada elige uno de los segundos que forman cada partido en nuestro estadio.</p>
                <p>Si en ese segundo el Real Murcia C.F. consigue marcar un gol, dar una asistencia, tirar al palo,
                    forzar su primer córner o le pitan un penalti a favor, recibirás un regalo.</p>
                <p>Únicamente tendrás que elegir un número del 1 al 5580 (minuto 93) y si este no ha sido elegido será
                    tuyo durante toda la temporada.</p>

                <b-row>
                    <b-col lg="6">
                        <ValidationProvider 
                            :name="'segundo_elegido' + index" 
                            :mode="manualMode" 
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <label for="segundo_elegido">Escribe Tu segundo</label>
                            <input 
                                type="number" 
                                v-model="localAbono.segundo_elegido" 
                                @input="() => { updateParent(); debouncedValidarSegundos(localAbono.segundo_elegido); }"
                                id="segundo_elegido"
                                name="segundo_elegido" 
                                min="1" 
                                max="5580"
                                :disabled="desactivar"
                            />
                            <span v-if="errors[0]" class="invalid-feedback mb-2 text-xs error-message">
                                <b>{{ errors[0]}}</b>
                            </span>
                        </ValidationProvider>
                        <label for="segundos_sugeridos" v-if="segundos_sugeridos.length > 0">Segundos sugeridos
                            disponibles</label>
                        <div v-if="segundos_sugeridos.length > 0">
                            <b-button 
                                v-for="(segundo, index) in segundos_sugeridos" 
                                :key="index"
                                variant="outline-primary" 
                                class="m-1"
                                @click="() => { localAbono.segundo_elegido = segundo; debouncedValidarSegundos(localAbono.segundo_elegido); }"
                            >
                                {{ segundo }}
                            </b-button>
                        </div>
                    </b-col>
                    <b-col lg="6" v-if="localAbono.segundo_elegido" class="my-auto text-center">
                        <span class="price price-large">⏰ {{ formatSeg(localAbono.segundo_elegido) }}</span>
                    </b-col>
                </b-row>
            </b-col>
            <div class="col-12 col-md-6 col-lg-12 pt-2" v-if="mostrar_tipo_abonos">
                <div class="form-group">
                    <div class="d-flex">
                        <label 
                            class="mr-2" 
                            for="descuento"
                        >
                            {{ $t('formularios.tipo_abono', {abono: teatro.texto_abono})}}
                        </label>
                        <label for="descuento" v-if="teatro.texto_extra_en_compra_de_abono">{{
                            teatro.texto_extra_en_compra_de_abono }}</label>
                    </div>
                    <ValidationProvider :name="'descuento' + index" rules="required" v-slot="{ errors }">
                        <multiselect 
                            :disabled="desactivar || getTiposPrecios(localAbono).length === 1" 
                            :class="(errors[0] ? 'is-invalid' : '')"
                            :allow-empty="false"
                            v-model="localAbono.tipo_abono"
                            :placeholder="$t('formularios.tipo_abono', {abono: teatro.texto_abono})" label="descripcion"
                            track-by="id" :options="getTiposPrecios(localAbono)"
                            @input="val => { 
                                updateParent(); 
                                if (!manager.lfp) getPrecio();
                            }"
                        />
                        <span 
                            v-if="errors[0]" 
                            class="invalid-feedback mb-4 text-xs"
                            style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                        >
                            <b>{{$t('formularios.seleccione_tipo_abono') }}</b>
                        </span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-12" v-if="precio && precio.solicitar_documentacion">
                <label>{{ precio.texto_documentacion }}</label>
                <Dropzone 
                    v-if="url" 
                    :url="url" 
                    :maxFilesize="maxFilesize" 
                    :maxFiles="5" 
                    @success="imagenSubida"
                    :acceptedFiles="'image/jpeg,image/png,image/gif,image/bmp,image/tiff,application/pdf,.pdf'" 
                />
                <h3 style="font-size: 19px;">Peso máximo de imágenes: {{ maxFilesize }} MB</h3>
            </div>
            <div class="col-12 form-group mt-3 pb-4" v-if="renovacion_automatica_disponible">
                <div class="checkbox-container">
                    <div class="col-12">
                        <p class="text-danger mb-0 ml-4 small">{{ error === 'no precios' ? $t('nuevo_abono.error_precio') : error }}</p>
                    </div>
                    <input 
                        type="checkbox" 
                        :name="'renovacion-automatica-' + index"
                        :id="'renovacion-automatica-' + index" 
                        :disabled="desactivar"
                        v-model="localAbono.renovacion_automatica"
                        @input="updateParent"
                    /> 
                    <label :for="'renovacion-automatica-' + index">
                        {{ $t('formularios.acepto_renovacion_automatica', { teatro: teatro.nombre }) }}, al marcar aceptas las <a href="#" @click.prevent="mostrarModalCondiciones">condiciones legales</a>
                    </label>
                </div>
            </div>
        </div>
        <ModalComponent 
            :name="'modalCondiciones' + index" 
            :title="$t('formularios.condiciones_renovacion_automatica') + ' ' + teatro.nombre"
            @close="CerrarModalCondiciones"
        >
                
            <div class="card-body">
                <div v-html="lista_abonados.renovacion_condiciones"></div>
            </div>
        </ModalComponent>
    </div>
</template>

<script>
    import Dropzone from '@/components/common/Dropzone';
    import Provincias from "../../../common/forms/Provincias";
    import Locations from "../../../common/forms/Locations";
    import Paises from "../../../common/forms/Paises";
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import FieldComponent from '@/components/common/FieldComponent.vue';
    import _ from 'lodash';
    import ModalComponent from '@/components/backend/components/ModalComponent.vue';
    import InfoToolTip from '@/components/common/InfoToolTip';

    export default {
        props: ['abono', 'generos', 'index', 'descuentos', 'tipos_abonos', 'tipo_abono_id', 'desactivar', 'validator', 'error_telefono'],
        data() {
            return {
                error: null,
                mostrar_tipo_abonos: false,
                precio: null,
                dropzoneOptions: {},
                maxDate: null,
                errors: [],
                provincia: null,
                pais: { id: 0 },
                mostrar_iban: this.$store.getters.getTeatro.mostrar_iban,
                mostrar_titular_cuenta: this.$store.getters.getTeatro.mostrar_titular_cuenta,
                bloquear_nombre_y_apellidos_en_renovacion: this.abono.n_abonado_antiguo ? this.$store.getters.getTeatro.bloquear_nombre_y_apellidos_en_renovacion : false,
                url: null,
                maxFilesize: 20,
                info_text: "A modo informativo queremos aconsejarle que sea cuál sea el formato en el que introduzca su documento de identidad lo recuerde para posibles futuros procesos",
                segundos_sugeridos: [], 
                localAbono: {
                    ...this.abono,
                },
                tipoDocumentoSeleccionado: null,
                texto_documentacion: 'seleccione el tipo de documento',
                tiposDocumento: [
                    { type: "DNI", value: "" },
                    { type: "NIE", value: "" },
                    { type: "NIF", value: "" },
                    { type: "PASAPORTE", value: "" }
                ]
            }
        },
        created() {
            this.setMaxDate();
            this.localAbono.tipoDocumentoSeleccionado = this.tiposDocumento.find(tipo => tipo.type === 'DNI');
            this.setTextoDocumentacion();

            if (this.teatro.provincia) {
                this.provincia = this.teatro.provincia;
            }

            this.localAbono.properties = {};

            // Debounce para getPrecio
            this.debouncedGetPrecio = _.debounce(this.getPrecio, 500);

            // Debounce para validarSegundos
            this.debouncedValidarSegundos = _.debounce(this.validarSegundos, 500);
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            tipos_renovacion() {
                var tipos = [];
                for(var i in this.tipos_abonos) {
                    if(this.tipos_abonos[i].renovacion &&  !this.tipos_abonos[i].exclusivo_penista) {
                        tipos.push(this.tipos_abonos[i]);
                    }
                }
                return tipos;
            },
            tipos_nuevo() {
                var tipos = [];
                for(var i in this.tipos_abonos) {
                    if(this.tipos_abonos[i].renovacion == 0 && !this.tipos_abonos[i].exclusivo_penista) {
                        tipos.push(this.tipos_abonos[i]);
                    }
                }
                return tipos;
            },
            tipos_penista() {
                var tipos = [];
                for(var i in this.tipos_abonos) {
                    if(this.tipos_abonos[i].exclusivo_penista == 1) {
                        tipos.push(this.tipos_abonos[i]);
                    }
                }
                return tipos;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            fields() {
                return this.lista_abonados.fields;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            coste_envio_whatsapp() {
                return parseFloat(this.teatro.coste_envio_whatsapp);
            },
            renovacion_automatica_disponible() {
                const listaAbonados = this.lista_abonados;
                if (listaAbonados && listaAbonados.renovacion_automatica) {
                    return true;
                }
                return false;
            }
        },
        mounted() {
            this.$emit('errorDatos', false);
            if(this.localAbono.n_abonado_antiguo) {
                if(this.localAbono.penista && this.tipos_penista.length > 0) {
                    if(this.tipos_penista.length > 1) {
                        this.mostrar_tipo_abonos = true;
                    } else if(this.tipos_penista.length == 1) {
                        this.localAbono.tipo_abono = this.tipos_penista[0];
                    }
                } else {
                    if(this.tipos_renovacion.length > 1) {
                        this.mostrar_tipo_abonos = true;
                    } else if(this.tipos_renovacion.length == 1) {
                        this.localAbono.tipo_abono = this.tipos_renovacion[0];
                        this.mostrar_tipo_abonos = false;
                    } else {
                        this.error = 'Esta zona no esta disponible';
                        this.mostrar_tipo_abonos = false;
                        this.$emit('errorDatos', true);
                    }
                }
            } else {
                if(this.tipos_nuevo.length > 1) {
                    this.mostrar_tipo_abonos = true;
                } else if(this.tipos_nuevo.length == 1) {
                    this.localAbono.tipo_abono = this.tipos_nuevo[0];
                    this.mostrar_tipo_abonos = false;
                } else {
                    this.error = 'Esta zona no esta disponible';
                    this.mostrar_tipo_abonos = false;
                    this.$emit('errorDatos', true);
                }
            }
            if (this.localAbono.fecha_nacimiento && !this.manager.lfp) {
                this.getPrecio();
            }
        },
        methods: {
            mostrarModalCondiciones()
            {
                this.$modal.show('modalCondiciones' + this.index);
            },
            CerrarModalCondiciones() {
                this.$modal.hide('modalCondiciones' + this.index);
            },
            updateParent() {
                this.$emit('updateAbono', { 
                    data: this.localAbono, 
                    index: this.index - 1 
                });
            },
            // Modo manual: sin eventos de validación automática
            manualMode() {
                return {};
            },
            formatSeg(segundo) {
                const minutes = Math.floor(segundo / 60);
                const remainingSeconds = segundo % 60;
                return `Min: ${minutes} - Seg: ${remainingSeconds}`;
            },
            validarSegundos(segundos) {
                const fieldName = 'segundo_elegido' + this.index;
                this.validator.setErrors({ [fieldName]: [] });

                if (segundos > 5580) {
                    this.validator.setErrors({
                        [fieldName]: ['El segundo seleccionado supera el máximo permitido (5580 segundos).']
                    });
                    return;
                }

                const params = {
                    lista_id: this.lista_abonados.id,
                    filters : {},
                    segundo_elegido: segundos
                };

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.segundos.disponible'), params).then(res => {
                    const fieldName = 'segundo_elegido' + this.index;
                    this.validator.setErrors({ [fieldName]: [] });    
                    this.segundos_sugeridos = [];            
                }).catch(error => {
                    this.segundos_sugeridos = error.response.data.segundos_sugeridos;
                    const errors = [];
                    const fieldName = 'segundo_elegido' + this.index;
                    errors[fieldName] = ['El segundo seleccionado no esta disponible'];
                    this.validator.setErrors(errors);
                });
            },
            getTiposPrecios(abono) {
                if(this.localAbono.n_abonado_antiguo) {
                    if(this.localAbono.penista && this.tipos_penista.length > 0) {
                        return this.tipos_penista;
                    } else {
                        return this.tipos_renovacion;
                    }
                } else {
                    return this.tipos_nuevo;
                }
            },
            setMaxDate() {
                var date = new Date();
                this.maxDate = date.toISOString();
            },
            getPrecio() {
                if(this.localAbono.fecha_nacimiento && this.localAbono.tipo_abono) {
                    if(this.localAbono.asiento) {
                        const params = {
                            filters: {
                                tid: this.configuracion.hash_teatro,
                                zona_id: this.localAbono.asiento ? this.localAbono.asiento.zona_id : null
                            },
                            tid: this.configuracion.hash_teatro,
                            fecha_nacimiento: this.localAbono.fecha_nacimiento,
                            zona_id: this.abono.asiento ? this.localAbono.asiento.zona_id : null,
                            tipo_abono: this.localAbono.tipo_abono
                        }

                        this.$store.dispatch(this.config.getVuexAlias('zonas.calcular.precio'), params)
                            .then(res => {
                                this.setDropZone();
                                this.precio = res.data.data;
                                this.localAbono.precio = res.data.data;

                                if(this.error){
                                    this.error = '';
                                    this.$emit('errorDatos', false);
                                }
                                this.mostrar_tipo_abonos = true;
                                this.$emit('precioDisponible', true);

                            })
                            .catch(error => {
                                this.error = 'no precios';
                                this.mostrar_tipo_abonos = false;
                                this.$emit('errorDatos', true);
                                this.$emit('precioDisponible', false);
                            });

                    } else {                        
                        var params_2 = {
                            filters: {
                                tid: this.configuracion.hash_teatro,
                                abono_id: this.localAbono.tipo_abono.id
                            },
                            tid: this.configuracion.hash_teatro,
                            fecha_nacimiento: this.localAbono.fecha_nacimiento,
                            abono_id: this.localAbono.tipo_abono.id,
                            datos_comprador: this.localAbono
                        }

                        this.$store.dispatch(this.config.getVuexAlias('front.abonos.precios.calcular.precio'), params_2)
                            .then(res => {
                                this.setDropZone();
                                this.precio = res.data.data;
                                this.localAbono.precio = res.data.data;

                                if(this.error){
                                    this.error = '';
                                    this.$emit('errorDatos', false);
                                }

                                this.mostrar_tipo_abonos = true;

                            })
                            .catch(error => {
                                this.error = 'no precios';
                                this.mostrar_tipo_abonos = false;
                                this.$emit('errorDatos', true);
                            });
                    }      
                }

            },
            imagenSubida(file, response) {
                if(!this.localAbono.documentaciones) {
                    this.localAbono.documentaciones = [];
                }
                this.$emit('imagenSubida');
                this.localAbono.documentaciones.push(response);
                this.updateParent();
            },
            setDropZone() {
                this.url = this.config.API_BASE + '/f/upload/documento?tid=' + this.configuracion.hash_teatro;
            },
            rellenarPais(pais) {
                this.localAbono.pais = pais.nombre;
                this.updateParent();
            },
            onSeleccionTipoDocumento(option) {
                this.tipoDocumentoSeleccionado = option;
                this.setTextoDocumentacion();
            },
            setTextoDocumentacion() {
                switch (this.localAbono.tipoDocumentoSeleccionado?.type) {
                    case 'DNI':
                        this.texto_documentacion = this.$t('formularios.dni');
                        break;
                    case 'NIE':
                        this.texto_documentacion = this.$t('formularios.nie');
                        break;
                    case 'NIF':
                        this.texto_documentacion = this.$t('formularios.nif');
                        break;
                    case 'PASAPORTE':
                        this.texto_documentacion = this.$t('formularios.pasaporte');
                        break;
                    default:
                        this.texto_documentacion = this.$t('formularios.tipo_identificacion');
                        break;
                }
            }
        },
        components: {
            Locations,
            Provincias,
            Paises,
            Dropzone,
            PhoneInput,
            FieldComponent,
            ModalComponent,
            InfoToolTip
        }
    }
</script>

<style scoped>
    #paso3 .multiselect__tags {
        border-color: #ccc;;
    }

    .multiselect__tags{
        min-height: 60px !important;
    }
    .dropzone-preview {
        position: relative;
        z-index: 1;
    }

    .price-large {
        font-size: 40px !important;  
    }
    .lightgray-content .checkbox-container input[type="checkbox"] + label:before, .lightgray-content .checkbox-container input[type="radio"] + label:before {
        background-color: #ededed;
    }
    .price-large {
        font-size: 40px !important;
        margin-bottom: 4em;
    }
    .price {
        margin-bottom: 4em;
    }
    .mb-3 {
        justify-content: center;
        align-items: center;
    }
    .my-auto {
        padding-top: 1em;
        padding-bottom: 1em;
        margin-top: 20em;
        font-family: 'Noway';
    }
    hr{
        width: 100%;
        height: 2px;
        margin-top: 1em;
        margin-bottom: 1em;
    }
    @media (max-width: 768px) {
        .price-large {
            font-size: 30px !important;
            margin-left: 0px;
        }
    }
    .error-message {
        font-size: 11px;
        display: block;
        background-color: #DC3545;
        color: white;
        padding: 6px;
    }
</style>
